import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '$shared/shared.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SharedBatchModule } from '../../shared-batch';
import {
  BatchesService,
  BatchesParseStorageService,
} from '../batches/services';
import { FiltersComponent } from './components/filters/filters.component';
import { InvoiceItemComponent } from './components/invoice-item/invoice-item.component';
import { ManageBatchReceiptComponent } from './components/manage-batch-receipt/manage-batch-receipt.component';
import { ShowFormedReceiptComponent } from './components/show-formed-receipt/show-formed-receipt.component';
import { InvoicesRoutingModule } from './invoices-routing.module';
import { InvoicesComponent } from './invoices.component';
import { IndexComponent } from './pages/index/index.component';
import { InvoicesService } from './services';

@NgModule({
  declarations: [
    InvoicesComponent,
    InvoiceItemComponent,
    IndexComponent,
    FiltersComponent,
    ManageBatchReceiptComponent,
    ShowFormedReceiptComponent,
  ],
  imports: [
    CommonModule,
    InvoicesRoutingModule,
    SharedBatchModule,
    SharedModule,
    ModalModule.forRoot(),
  ],
  providers: [InvoicesService, BatchesService, BatchesParseStorageService],
})
export class InvoicesModule {}
